import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';

import { useWarning } from '@mssgme/hooks';
import { NoAccess } from '../NoAccess';
import { NoAccessOverlay } from '../NoAccessOverlay';
import { PortalModalSheet } from '../../ModalSheet';

const RestrictionContext = React.createContext();

// todo: split into RestrictionScope, OverlayRestrictionScope and ModalRestrictionScope
export default function RestrictionScope({ children, overlay, noVisuals, fullWidth = true, modal = true, ...rest }) {
    const { isPresented, warning, hide } = useWarning();
    const nested = useContext(RestrictionContext);
    const isAlreadyPresented = isPresented && nested === warning;
    const upgradePath = warning?.target && `/billing/plans/${warning?.target}`;
    const canUseOverlay = overlay && !modal;
    const overlayWarning = overlay?.code ? overlay : warning;
    const showedWarning = canUseOverlay ? overlayWarning : warning;

    if (isPresented && canUseOverlay && showedWarning) {
        return (
            <NoAccessOverlay warning={showedWarning} {...rest}>
                {children}
            </NoAccessOverlay>
        );
    }

    if (modal) {
        return (
            <>
                {noVisuals && upgradePath && <Redirect to={upgradePath} />}

                {/* this is the only place we care to wrap into RestrictionContext, as other
                    wouldn't have trouble with nesting */}
                <RestrictionContext.Provider value={showedWarning}>{children}</RestrictionContext.Provider>

                <AnimatePresence>
                    {isPresented && !isAlreadyPresented && (
                        <PortalModalSheet fullWidth={fullWidth} onClose={hide} padding={false}>
                            <NoAccess reason={showedWarning} onCancel={hide} {...rest} />
                        </PortalModalSheet>
                    )}
                </AnimatePresence>
            </>
        );
    }

    return isPresented ? <NoAccess reason={showedWarning} onCancel={hide} {...rest} /> : children;
}

RestrictionScope.propTypes = {
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    overlay: PropTypes.any,
    fullWidth: PropTypes.bool,
    noVisuals: PropTypes.bool,
    modal: PropTypes.bool,
};
